import * as React from 'react';
import { styled } from '../../theme';
import { ArrowBoxWidget } from '../menus/ArrowBoxWidget';
import { DateTime } from 'luxon';
import { Notification } from '../../stores/NotificationStore';
import { useEffect } from 'react';

export interface NotificationsLayerWidgetProps {
  notifications: Notification[];
  close: () => any;
}

export const NotificationsLayerWidget: React.FC<NotificationsLayerWidgetProps> = (props) => {
  return (
    <S.Notifications>
      <ArrowBoxWidget>
        <S.NotificationsHeader>Notifications</S.NotificationsHeader>
        <S.NotificationsContainer>
          {props.notifications.map((n) => {
            return <NotificationWidget closed={props.close} notification={n} key={n.id} />;
          })}
        </S.NotificationsContainer>
        {props.notifications.length === 0 ? <S.NoNotifications>You have no notifications.</S.NoNotifications> : null}
      </ArrowBoxWidget>
    </S.Notifications>
  );
};

export const NotificationWidget: React.FC<{ notification: Notification; closed: () => any }> = (props) => {
  useEffect(() => {
    return props.notification.registerListener({
      closed: props.closed
    });
  }, []);
  return (
    <S.Notification
      onClick={() => {
        props.notification.action?.();
      }}
    >
      <S.NotificationHeader>
        <S.NotificationLabel>{props.notification.options.label}</S.NotificationLabel>
        <S.NotificationDate>{DateTime.fromJSDate(props.notification.options.date).toRelative()}</S.NotificationDate>
      </S.NotificationHeader>
      <S.NotificationText>{props.notification.options.text}</S.NotificationText>
    </S.Notification>
  );
};

namespace S {
  export const Notifications = styled.div`
    position: absolute;
    top: 10px;
    right: -49px;
    z-index: 2;
  `;

  export const NotificationsContainer = styled.div``;

  export const NotificationsHeader = styled.div`
    font-family: ${(p) => p.theme.text.fontFamily};
    font-weight: 400;
    font-size: 20px;
    color: ${(p) => p.theme.text.secondary};
    padding: 10px;
    padding-bottom: 10px;
  `;

  export const Notification = styled.div`
    width: 300px;
    padding: 15px;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  `;

  export const NotificationHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 5px;
  `;

  export const NoNotifications = styled.div`
    font-family: ${(p) => p.theme.text.fontFamily};
    font-weight: 400;
    font-size: 15px;
    color: ${(p) => p.theme.text.secondary};
    font-style: italic;
    padding: 10px;
    opacity: 0.6;
    white-space: nowrap;
  `;

  export const NotificationLabel = styled.div`
    color: white;
    font-size: 15px;
  `;

  export const NotificationDate = styled.div`
    color: white;
    font-size: 10px;
    opacity: 0.6;
    margin-left: 10px;
  `;

  export const NotificationText = styled.div`
    color: white;
    font-size: 13px;
    opacity: 0.6;
  `;

  export const MarkAsSeen = styled.div``;
}
